module.exports = __webpack_public_path__ + "img/banner-home_tbao.b0ef7844.jpg";